import {
  Pill,
  Leaf,
  FlaskConical,
  Microscope,
  Dna,
  Hospital,
  UtensilsCrossed,
  Car,
  Factory,
  Anchor,
  Warehouse,
} from 'lucide-react';

/**
 * Sectors served — shared by Home and Industries pages.
 * imageIndex maps to project photos in public/gallery/ (category-aligned in siteGallery).
 */
export const INDUSTRIES_SERVED = [
  {
    id: 'pharmaceuticals',
    title: 'Pharmaceuticals',
    imageIndex: 0,
    imageAlt: 'Pharmaceutical cleanroom epoxy flooring',
    icon: Pill,
    description:
      'GMP-compliant seamless flooring for formulation, aseptic production, packaging, and sterile process areas.',
    features: ['Seamless & hygienic', 'Chemical resistant', 'GMP / cleanroom suitable'],
  },
  {
    id: 'nutraceuticals',
    title: 'Nutraceuticals',
    imageIndex: 5,
    imageAlt: 'Nutraceutical production area flooring',
    icon: Leaf,
    description:
      'Hygienic resin floors for supplement manufacturing, blending, and packing zones with strict cleanliness requirements.',
    features: ['Easy to sanitise', 'Dust-free finish', 'Durable under plant traffic'],
  },
  {
    id: 'research-development',
    title: 'Research & Development',
    imageIndex: 10,
    imageAlt: 'R&D facility epoxy floor system',
    icon: FlaskConical,
    description:
      'Coating systems for R&D labs and pilot plants where chemical resistance and cleanability are essential.',
    features: ['Solvent & spill resistant', 'Low maintenance', 'Specified system build-up'],
  },
  {
    id: 'laboratories',
    title: 'Laboratories',
    imageIndex: 15,
    imageAlt: 'Laboratory epoxy flooring installation',
    icon: Microscope,
    description:
      'Seamless, non-porous floors for analytical, QA, and microbiology laboratories with controlled hygiene needs.',
    features: ['Non-porous surface', 'Contamination control', 'Compatible with coving'],
  },
  {
    id: 'biotech-plant',
    title: 'Biotech – Plant',
    imageIndex: 20,
    imageAlt: 'Biotech plant flooring application',
    icon: Dna,
    description:
      'Epoxy and PU systems for biotech production suites, upstream/downstream areas, and support utilities.',
    features: ['Clean process suitable', 'Thermal & chemical resistance', 'Trained site application'],
  },
  {
    id: 'hospitals-clean-rooms',
    title: 'Hospitals & Clean Rooms',
    imageIndex: 25,
    imageAlt: 'Hospital and cleanroom floor coating',
    icon: Hospital,
    description:
      'Flooring for OTs, ICUs, diagnostics, and hygiene-critical hospital zones requiring seamless, washable surfaces.',
    features: ['Hygienic seamless finish', 'Anti-slip options', 'Wall–floor coving available'],
  },
  {
    id: 'food-beverages',
    title: 'Food & Beverages',
    imageIndex: 1,
    imageAlt: 'Food and beverage plant flooring',
    icon: UtensilsCrossed,
    description:
      'Food-grade epoxy and PU systems for processing, bottling, dairy, and commercial kitchen environments.',
    features: ['HACCP-oriented systems', 'Thermal shock resistant', 'Anti-slip & washable'],
  },
  {
    id: 'automobiles-engineering',
    title: 'Automobiles Engineering',
    imageIndex: 8,
    imageAlt: 'Automotive engineering plant floor',
    icon: Car,
    description:
      'Heavy-duty floors for assembly shops, paint areas, and service bays with oil, fuel, and traffic resistance.',
    features: ['Oil & chemical resistant', 'High load durability', 'ESD options where required'],
  },
  {
    id: 'engineering-manufacturing',
    title: 'Engineering & Manufacturing Plant',
    imageIndex: 3,
    imageAlt: 'Engineering and manufacturing facility flooring',
    icon: Factory,
    description:
      'Industrial epoxy systems for machine shops, fabrication, and continuous manufacturing with forklift and impact loads.',
    features: ['Impact & abrasion resistant', 'Chemical spill protection', 'Long service life'],
  },
  {
    id: 'marine-flooring',
    title: 'Marine Flooring',
    imageIndex: 14,
    imageAlt: 'Marine and coastal industrial flooring',
    icon: Anchor,
    description:
      'Protective coatings for marine workshops, port facilities, and coastal plants exposed to moisture and harsh conditions.',
    features: ['Moisture-tolerant systems', 'Corrosion protection', 'Heavy-duty wear resistance'],
  },
  {
    id: 'warehouses-cold-storage',
    title: 'Warehouses & Cold Storages',
    imageIndex: 2,
    imageAlt: 'Warehouse and cold storage epoxy floor',
    icon: Warehouse,
    description:
      'Durable floors for logistics hubs, distribution centres, and cold rooms with thermal cycling and pallet traffic.',
    features: ['Forklift rated', 'Temperature cycling resistant', 'Dust-proof sealed surface'],
  },
];
